import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { findColor, findSizeBySku, determineSelectedSku } from '@as-react/common-utils';
import { isProductInWishList } from '../../../util/WishListUtil';
import { ProductTileLook } from '../../product-tile/look/ProductTileLook';
export const MiniPDPMultiProductTile = ({ handleSetError, index, isShopLanding, onProductChange, onWishListToggle, productData: { product, isSelected = false, sku, colorId }, sizeSelectError, tileIdSuffix = '', wishlistProducts, }) => {
    const selectedColor = findColor(product.colours, colorId);
    const [selectedSize, setSelectedSize] = useState(findSizeBySku(selectedColor.sizes, sku));
    const isSelectedColorOutOfStock = selectedColor.availability <= 0;
    const isProductOutOfStock = product.colours.filter(color => color.availability > 0).length === 0;
    const resetSelectError = () => {
        sizeSelectError && handleSetError(false, index);
    };
    const setProductColor = (id) => {
        const activeColor = findColor(product.colours, id);
        const activeSku = determineSelectedSku(activeColor);
        resetSelectError();
        setSelectedSize(findSizeBySku(activeColor.sizes, activeSku));
        onProductChange({
            product,
            colorId: activeColor.colourId,
            sku: activeSku,
            quantity: 1,
            isSelected,
        });
    };
    const handleSizeChange = (activeSku) => {
        resetSelectError();
        const currentSize = findSizeBySku(selectedColor.sizes, activeSku);
        setSelectedSize(currentSize);
        onProductChange({
            product,
            colorId: selectedColor.colourId,
            sku: activeSku,
            quantity: 1,
            isSelected: (currentSize === null || currentSize === void 0 ? void 0 : currentSize.storeSourceExcluded) ? false : isSelected,
        });
    };
    const toggleWishList = () => onWishListToggle({
        productId: product.productId,
        productCode: product.productCode,
        colorId: selectedColor.colourId,
        sku,
        colorCode: selectedColor.colourCode,
        color: selectedColor.description,
    });
    const handleProductSelect = (e) => {
        resetSelectError();
        onProductChange({ product, colorId: selectedColor.colourId, sku, quantity: 1, isSelected: e.target.checked });
    };
    useEffect(() => {
        if (isSelectedColorOutOfStock && isSelected) {
            onProductChange({ product, colorId, sku, isSelected: false, quantity: 1 });
        }
    }, [isSelectedColorOutOfStock]);
    return (_jsx(ProductTileLook, { product: product, selectedSize: selectedSize, selectedColor: selectedColor, isColourOutOfStock: isProductOutOfStock ? false : isSelectedColorOutOfStock, isProductOutOfStock: isProductOutOfStock, inWishList: isProductInWishList(wishlistProducts, product.productId, selectedColor.colourId), isSelected: isSelected, onWishListClick: isShopLanding ? undefined : toggleWishList, onProductSelect: handleProductSelect, analyticsAreaName: "pdp-link-shop-the-look", idSuffix: `${tileIdSuffix}-${index}`, sizeSelectError: sizeSelectError, onSizeChange: handleSizeChange, onColorChange: setProductColor }));
};
